import { useState } from 'react';

import { EyeOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import { useGetActivitiesListQuery } from 'services';

import HistoryModal from './history-modal';

const ActivityHistory = ({ id, requestType = 'committee_control' }) => {
  const { data, isLoading, isError, isFetching } = useGetActivitiesListQuery({
    entityId: id,
    requestType,
  });
  const [showModal, setShowModal] = useState(false);

  if (isLoading || isError) return null;

  return (
    <>
      <Card>
        <div className="gx-d-flex gx-align-items-center gx-justify-content-between">
          <h4 className="gx-mb-0">Geçmiş Hareketler</h4>
          <Button
            type="primary"
            className="gx-mb-0 gx-d-flex gx-align-items-center"
            onClick={() => setShowModal(true)}
          >
            <EyeOutlined />
            Görüntüle
          </Button>
        </div>
      </Card>
      <HistoryModal
        open={showModal}
        onClose={() => setShowModal(false)}
        dataSource={data?.data}
        isFetching={isFetching}
      />
    </>
  );
};

export default ActivityHistory;
